export const STATES = {
    //SOLICITUD
    '00-0000' : {
        STEP_ID: '1',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    '05-0010' : {
        STEP_ID: '1',
        TEXT_INFO_TITLE: 'Pronto recogeremos tu dispositivo',
        TEXT_INFO_DESC: 'Nuestra empresa de transporte Zeleris recogerá tu dispositivo',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    '05-0100' : {
        STEP_ID: '1',
        TEXT_INFO_TITLE: 'No hemos podido recoger tu dispositivo en la dirección indicada',
        TEXT_INFO_DESC: 'Contactaremos contigo para fijar una nueva cita',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    //RECOGIDA
    '05-0500' : {
        STEP_ID: '2',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    '05-0600' : {
        STEP_ID: '2',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    '80-0150' : {
        STEP_ID: '2',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    //EN_REVISION
    '15-0150' : {
        STEP_ID: '3',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    //DIAGNOSTICO,
    '15-0200' : {
        STEP_ID: '4',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    '80-0550' : {
        STEP_ID: '4',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    '80-9100' : {
        STEP_ID: '4',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    '20-0500' : {
        STEP_ID: '4',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    '20-0550' : {
        STEP_ID: '4',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    '80-0200' : {
        STEP_ID: '4',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    '20-0850' : {
        STEP_ID: '4',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    '80-0750' : {
        STEP_ID: '4',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    //PAGO,
    '25-0100' : {
        STEP_ID: '5',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    '25-0100' : {// despues de 80-0150
        STEP_ID: '5',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },

    //DEVOLUCION
    '20-0800' : {
        STEP_ID: '6',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    //SIN STEPPER
    NO_RECOGIDO_DEFINITIVO : {
        STEP_ID: '0',
        CODE: '99-9999',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
    ORDEN_DESTRUCCION : {
        STEP_ID: '0',
        CODE: '00-0000',
        TEXT_INFO_TITLE: 'Hemos recibido correctamente tu solicitud de venta',
        TEXT_INFO_DESC: 'Te enviaremos un mail para informarte sobre la recogida',
        NEXT_STEP: ['Recogeremos el dispositivo en 1-3 días laborables desde la fecha de confirmación de la solicitud de venta. Recibirás un SMS de nuestra empresa de transportes Zeleris para informarte. No necesitas empaquetarlo. ¡Nosotros nos encargamos de todo! Ten en cuenta lo siguiente:', 
        '- Desactiva cualquier bloqueo del dispositivo ',
        '- Envía solo el equipo (sin accesorios ni tarjetas SIM o de memoria)', 
        '- Borra los datos del equipo (recuerda hacer una copia de seguridad)',
        '- Asegúrate de que el dispositivo esté cargado'],
    },
}
export const STEPS = {
    SOLICITUD : {
        ID: '1',
        LABEL: 'Solicitud',
        STATES: ['00-0000','05-0010','05-0100'],
    },
    RECOGIDA : {
        ID: '2',
        LABEL: 'Recogida',
        STATES: ['05-0500','05-0600','80-0150']

    },
    EN_REVISION : {
        ID: '3',
        LABEL: 'En revision',
        STATES: ['15-0150']
    },
    DIAGNOSTICO : {
        ID: '4',
        LABEL: 'Diagnostico',
        STATES: ['15-0200','80-0550','80-9100','20-0500','20-0550','80-0200','20-0850','80-0750']
    },
    PAGO : {
        ID: '5',
        LABEL: 'Pago',
        STATES: ['25-0100', '25-0100']
    },
    DEVOLUCION : {
        ID: '6',
        LABEL: 'Devolucion',
        STATES: ['20-0800']
    },
}
